module.exports = __webpack_public_path__ + "static/media/clothing-by-thom-bradley.1a614dfa.jpg";